import { lazy, Suspense, useMemo } from 'react';
import { Navbar } from '@/components/layout/Navbar';
import { Hero } from '@/components/landing/Hero';
import { PageSEO } from '@/components/seo/PageSEO';

// Lazy load below-the-fold components to reduce initial bundle
const Features = lazy(() => import('@/components/landing/Features').then(m => ({ default: m.Features })));
const PricingSection = lazy(() => import('@/components/landing/PricingSection').then(m => ({ default: m.PricingSection })));
const Footer = lazy(() => import('@/components/landing/Footer').then(m => ({ default: m.Footer })));

const Index = () => {
  const jsonLd = useMemo(() => ({
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "name": "The Project Alpha Trading Community™",
        "url": "https://projectalphacommunity.lovable.app",
        "logo": "https://projectalphacommunity.lovable.app/favicon.png",
        "description": "Where our members learn trading strategies, share ideas, and grow with fellow traders."
      },
      {
        "@type": "WebSite",
        "name": "Project Alpha",
        "url": "https://projectalphacommunity.lovable.app"
      }
    ]
  }), []);

  return (
    <div className="min-h-screen bg-background dark">
      <PageSEO
        title="The Project Alpha Trading Community™"
        description="Where our members learn trading strategies, share ideas, and grow with fellow traders."
        path="/"
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        <Hero />
        <Suspense fallback={<div className="min-h-[400px]" />}>
          <Features />
          <PricingSection />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
